import PropTypes from "prop-types";
import { useEffect, useState } from "react";

/**
 * PropertyDetails component displays Details like Beds, Baths, PropertyType and square footage on Listing Feed Page
 * @param {Object} props - Component props
 * @param {number} props.beds - Total Number of Beds
 * @param {string} props.baths - Total Number of Baths
 * @param {number} props.sqFt - Properties Square footage
 * @param {string} props.type - Type of Property
 * @returns {JSX.Element} - Overlay on PropertySwiper for Listing Feed.
 */
export function PropertyDetails({ beds, baths, sqFt, type }) {
    const [propertyType, setPropertyType] = useState("Loading...");

    useEffect(() => {
        if (type === "Single Family Residential") {
            setPropertyType("House");
        } else if (type === "Condominium") {
            setPropertyType("Condo");
        }
    }, [type]); //eslint-disable-next-line

    return (
        <div className="tw-flex tw-flex-row tw-justify-between bg-black/60 tw-px-4 tw-py-1 text-white">
            <div className="tw-flex !tw-justify-center !tw-items-center">
                <i className="tw-p-2 fa-solid fa-bed"></i>
                <span className="tw-text-xl tw-font-bold">{beds}</span>
            </div>

            <div className="tw-flex  !tw-justify-center !tw-items-center">
                <i className="tw-p-2 fa-solid fa-bath"></i>
                <span className="tw-text-xl tw-font-bold">{baths}</span>
            </div>
            <div className="tw-flex  !tw-justify-center !tw-items-center">
                <i className="tw-p-2 fa-solid fa-maximize"></i>
                <span className="tw-text-xl tw-font-bold">{sqFt === 0 ? "Unknown" : sqFt}</span>
            </div>

            <div className="tw-flex  !tw-justify-center !tw-items-center">
                <i className="tw-p-2 fa-solid fa-house-circle-exclamation"></i>
                <span className="tw-text-xl tw-font-bold">{propertyType}</span>
            </div>
        </div>
    );
}

PropertyDetails.propTypes = {
    beds: PropTypes.number.isRequired,
    baths: PropTypes.string.isRequired,
    sqFt: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
};
